import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { IM_MessageType } from './../interfaces/message';
import { ActionComponent } from './action.component';
import { UIEventEmitter } from '../utilitites/ui-events';
import { UIEvents } from '../utilitites/application.constants';
import { Guid } from '../../../../common';
import { IM_MessageComponent } from './message-components/im-message.component';
export var BridgeComponent = function (_React$Component) {
  _inherits(BridgeComponent, _React$Component);

  var _super = _createSuper(BridgeComponent);

  function BridgeComponent(state, props) {
    var _this;

    _classCallCheck(this, BridgeComponent);

    _this = _super.call(this, state, props);

    _defineProperty(_assertThisInitialized(_this), "_globalWindowObject", void 0);

    _defineProperty(_assertThisInitialized(_this), "_globalDocumentObject", void 0);

    _defineProperty(_assertThisInitialized(_this), "_loggerInstance", void 0);

    _defineProperty(_assertThisInitialized(_this), "addRemoteMediaStream", function (video) {
      var mediaStream = _this.props.remoteMediaStream;

      _this.playVideo(mediaStream, video);

      _this._globalWindowObject.dispatchCustomEvent("onCallStarted", {});
    });

    _defineProperty(_assertThisInitialized(_this), "addLocalMediaStream", function (video) {
      var mediaStream = _this.props.localMediaStream;

      _this.playVideo(mediaStream, video);
    });

    _defineProperty(_assertThisInitialized(_this), "addLocalMediaStreamForWaitingStatus", function (video) {
      var mediaStream = _this.props.localMediaStream;

      _this.playVideo(mediaStream, video);
    });

    _defineProperty(_assertThisInitialized(_this), "showMyVideo", function (event) {
      try {
        var videoElement = _this._globalDocumentObject.getElementById("localMedia");

        _this.pictureInPicture("localMedia", videoElement !== _this._globalDocumentObject.pictureInPictureElement);

        if (event && event.preventDefault) {
          event === null || event === void 0 ? void 0 : event.preventDefault();
        }

        var updatedStatus = !_this.state.isShowMyVideoPreviewOff;

        _this.setState({
          isShowMyVideoPreviewOff: updatedStatus
        });
      } catch (ex) {
        _this._loggerInstance.logException(ex);
      }
    });

    _this._loggerInstance = window['Logger'];
    _this._globalWindowObject = window;
    _this._globalDocumentObject = document;
    _this.state = {
      messageList: [],
      newMessage: '',
      showVideoControls: false,
      localMediaStreamForWaitingStatus: null,
      isShowMyVideoPreviewOff: true
    };
    return _this;
  }

  _createClass(BridgeComponent, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this._loggerInstance.logTrace("componentWillMount invoked for bridge component");

      this._globalWindowObject.setMessageAreaHeight = this.setMessageAreaHeight;

      this._globalWindowObject.addEventListener('onPrescriptionFromDoctor', this.onPrescriptionFromDoctor.bind(this));

      this._globalWindowObject.addEventListener('resize', this.setMessageAreaHeight);

      this._globalWindowObject.addEventListener('onVideoBlur', this.onVideoBlur.bind(this));

      this._globalWindowObject.addEventListener('onVideoActivate', this.onVideoActivate.bind(this));

      this._globalWindowObject.addEventListener('touchstart', this.setTouchStart.bind(this));

      UIEventEmitter.getInstance().subscribe(UIEvents.OnShowMyVideoClicked, this.showMyVideo.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      UIEventEmitter.getInstance().unsubscribe(UIEvents.OnShowMyVideoClicked, this.showMyVideo.bind(this));

      this._globalWindowObject.removeEventListener('onPrescriptionFromDoctor', this.onPrescriptionFromDoctor.bind(this));

      this._globalWindowObject.removeEventListener('resize', this.setMessageAreaHeight);

      this._globalWindowObject.removeEventListener('onVideoBlur', this.onVideoBlur.bind(this));

      this._globalWindowObject.removeEventListener('onVideoActivate', this.onVideoActivate.bind(this));

      this._globalWindowObject.removeEventListener('touchstart', this.setTouchStart.bind(this));
    }
  }, {
    key: "addMessage",
    value: function addMessage(message) {
      var messageList = this.state.messageList;
      messageList.push(message);
      this.setState({
        messageList: messageList
      });
      this.setMessageAreaHeight();
    }
  }, {
    key: "onVideoBlur",
    value: function () {
      var _onVideoBlur = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._loggerInstance.logEvent("Picture in Picture View on");

                this.pictureInPicture("localMedia", false);
                this.pictureInPicture('remoteMedia', true);
                e.preventDefault();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onVideoBlur(_x) {
        return _onVideoBlur.apply(this, arguments);
      }

      return onVideoBlur;
    }()
  }, {
    key: "onVideoActivate",
    value: function () {
      var _onVideoActivate = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(e) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  this._loggerInstance.logEvent("Picture in Picture View off");

                  this.pictureInPicture('remoteMedia', false);
                  this.pictureInPicture("localMedia", true);
                } catch (error) {
                  console.log("Browser doesn't have picture-in-picture capability");
                }

                e.preventDefault();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onVideoActivate(_x2) {
        return _onVideoActivate.apply(this, arguments);
      }

      return onVideoActivate;
    }()
  }, {
    key: "pictureInPicture",
    value: function () {
      var _pictureInPicture = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(elementid, activate) {
        var videoElement;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                videoElement = this._globalDocumentObject.getElementById(elementid);
                _context3.prev = 1;

                if (!activate) {
                  _context3.next = 8;
                  break;
                }

                if (!(videoElement !== this._globalDocumentObject.pictureInPictureElement)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return videoElement.requestPictureInPicture();

              case 6:
                _context3.next = 11;
                break;

              case 8:
                if (!this._globalDocumentObject.pictureInPictureElement) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 11;
                return this._globalDocumentObject.exitPictureInPicture();

              case 11:
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](1);
                console.log("Browser doesn't have picture-in-picture capability");

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 13]]);
      }));

      function pictureInPicture(_x3, _x4) {
        return _pictureInPicture.apply(this, arguments);
      }

      return pictureInPicture;
    }()
  }, {
    key: "playVideo",
    value: function playVideo(mediaStream, videoElement) {
      var self = this;

      if (videoElement && mediaStream) {
        videoElement.srcObject = mediaStream;
        videoElement.play();
        setTimeout(function () {
          self.setMessageAreaHeight(videoElement);
        }, 100);
      }
    }
  }, {
    key: "setFocus",
    value: function setFocus() {
      var container = document.getElementById('messageArea');

      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    }
  }, {
    key: "onTextMessageSubmitHandler",
    value: function onTextMessageSubmitHandler(event) {
      var messageText = this.state.newMessage;
      var updatedMessageList = this.state.messageList;
      var message = {
        message: messageText,
        messageFrom: 'You',
        postedOn: new Date(),
        messageId: Guid.NewGuid(),
        messageType: IM_MessageType.MessageFromPeer
      };
      updatedMessageList.push(message);
      this.setState({
        messageList: updatedMessageList
      });
      this.props.onSendMessageToPeer(message);
      this.setState({
        newMessage: ''
      });
      event.preventDefault();
    }
  }, {
    key: "onPrescriptionFromDoctor",
    value: function onPrescriptionFromDoctor(e) {
      if (!e.detail) return;

      this._loggerInstance.logEvent("Prescription from Doctor");

      var displayText = e.detail.message;
      var messageType = e.detail.messageType;
      var prescriptionLink = e.detail.link;

      if (!(prescriptionLink && messageType)) {
        return;
      }

      var prescriptionMessage = {
        messageId: Guid.NewGuid(),
        postedOn: new Date(),
        message: displayText,
        prescriptionLink: prescriptionLink,
        messageFrom: 'You',
        messageType: IM_MessageType.PrescriptionMessage
      };
      var updatedMessageList = this.state.messageList;
      updatedMessageList.push(prescriptionMessage);
      this.setState({
        messageList: updatedMessageList
      });
      this.props.onSendMessageToPeer(prescriptionMessage);
      this.setState({
        newMessage: ''
      });
      e.preventDefault();
    }
  }, {
    key: "onMessageEnter",
    value: function onMessageEnter(e) {
      try {
        this.setState({
          newMessage: e.target.value
        });
      } catch (e) {}
    }
  }, {
    key: "setMessageAreaHeight",
    value: function setMessageAreaHeight(videoElement) {
      setTimeout(function () {
        var video = videoElement ? videoElement : document.getElementById('remoteMedia');
        var messageArea = document.getElementById('messageArea');
        var messageBox = document.getElementById('messagebox');
        var videoActionControl = document.getElementById('videoActionControl');

        if (video && messageBox && messageArea) {
          var height = video.offsetHeight - (messageBox.offsetHeight + videoActionControl.offsetHeight);
          messageArea.style.height = height + 'px';
        }
      }, 200);
    }
  }, {
    key: "setTouchStart",
    value: function setTouchStart() {
      var _event;

      this.setState({
        showVideoControls: true
      });
      (_event = event) === null || _event === void 0 ? void 0 : _event.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.props.isVisible ? React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-md-8",
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({
            showVideoControls: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            showVideoControls: false
          });
        },
        touchstart: function touchstart() {
          return _this2.setState({
            showVideoControls: true
          });
        }
      }, React.createElement("div", {
        className: "col-md-12 no-gutter",
        id: "left-SidebarDashboardVC",
        style: {
          borderRight: '1px solid #42BFAB'
        }
      }, this.props.isCallConnected ? React.createElement("div", null, React.createElement("video", {
        id: "remoteMedia",
        className: "col-md-12 no-gutter embed-responsive-item videoElement",
        title: "Remote Video",
        style: {
          backgroundColor: 'black'
        },
        autoPlay: true,
        controls: true,
        ref: this.props.remoteMediaStream ? this.addRemoteMediaStream : null
      }, React.createElement("track", {
        "default": true,
        kind: "captions"
      })), React.createElement("video", {
        id: "localMedia",
        width: "0",
        height: "0",
        className: "col-md-12 no-gutter embed-responsive-item videoElement",
        title: "Your Video",
        style: {
          display: 'none'
        },
        autoPlay: true,
        controls: true,
        muted: true,
        ref: this.props.localMediaStream ? this.addLocalMediaStream : null
      }, React.createElement("track", {
        "default": true,
        kind: "captions"
      }))) : React.createElement("video", {
        id: "localMediaForWaitingState",
        className: "embed-responsive-item videoElement",
        title: "Remote Video",
        style: {
          backgroundColor: 'black'
        },
        autoPlay: true,
        controls: true,
        muted: true,
        autopictureinpicture: true,
        ref: this.props.localMediaStream ? this.addLocalMediaStreamForWaitingStatus : null
      }, React.createElement("track", {
        "default": true,
        kind: "captions"
      })))), React.createElement("div", {
        className: "col-md-4 column-right",
        style: {
          verticalAlign: 'top',
          paddingLeft: 0
        }
      }, React.createElement(ActionComponent, {
        isCallConnected: this.props.isCallConnected,
        isWaiting: this.props.isWaiting,
        isOnMute: this.props.isOnMute,
        isShowMyVideoPreviewOff: this.state.isShowMyVideoPreviewOff,
        isVideoOff: this.props.isVideoOff
      }), React.createElement("div", {
        className: "chat-message",
        id: "rightbarMessage",
        style: {
          background: '#EFEDED'
        }
      }, React.createElement("div", {
        className: "d-flex flex-column"
      }, React.createElement("div", {
        className: "p-2 bg-light message-area",
        id: "messageArea"
      }, React.createElement(IM_MessageComponent, {
        im_messages: this.state.messageList
      })), React.createElement("form", {
        id: "messageEditorForm",
        onSubmit: this.onTextMessageSubmitHandler.bind(this)
      }, React.createElement("div", {
        className: "input-group"
      }, React.createElement("input", {
        type: "text",
        className: "form-control",
        autoComplete: "off",
        disabled: !this.props.isCallConnected,
        value: this.state.newMessage,
        onChange: this.onMessageEnter.bind(this),
        id: "messagebox",
        placeholder: "Enter message here. "
      }), React.createElement("div", {
        className: "input-group-btn"
      }, React.createElement("button", {
        className: "btn greenBtn btn-default",
        id: "sendmessage",
        disabled: !this.props.isCallConnected,
        value: "Send",
        type: "submit"
      }, "Send"))))))), React.createElement("div", {
        className: "clear"
      })) : React.createElement("div", null);
    }
  }]);

  return BridgeComponent;
}(React.Component);